import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {ActivatedRoute, Router} from '@angular/router';
import { URLSearchParams } from '@angular/http';

@Component({
  selector: "app-dads-and-grads",
  templateUrl: "./dads-and-grads.component.html",
  styleUrls: ["./dads-and-grads.component.scss"]
})
export class DadsAndGradsComponent implements OnInit {
  public fiestaClubForm: FormGroup;
  public formSentSuccess = false;
  public formSubmitting = false;
  public showErrorMessage = false;


  constructor(private _fb: FormBuilder, private _router: Router) {}

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/dads-and-grads/dads-and-grads.component.ts